import React from 'react';
import { NavLink } from 'react-router-dom';
import dlzLogo from '../pages/logo-dlz.png';
import MenuIcon from '@mui/icons-material/Menu';
import {AppBar, Box, Button, IconButton, Toolbar, Typography} from '@mui/material';

export default function NavBar(){
  const linkStyle = ({ isActive }) => ({
    color: 'black',
    textDecoration: 'none',
    marginRight: 12,
    borderBottom: isActive ? '2px solid red' : 'none'
  });

  return (
    // <AppBar position="static">
    //   <Toolbar>
    //     <Button color="inherit" component={NavLink} to="/" style={linkStyle}>Home</Button>
    //     <Button color="inherit" component={NavLink} to="/about" style={linkStyle}>About</Button>
    //     <Button color="inherit" component={NavLink} to="/contact" style={linkStyle}>Contact</Button>
    //   </Toolbar>
    // </AppBar>

        <Box sx={{ flexGrow: 1 , width: '100%'}}>
        <AppBar position="static" sx={{backgroundColor: '#dddddd'}}>
            <Toolbar>
            {/* <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ mr: 2, color: '#000000' }}
            >
                <MenuIcon />
            </IconButton> */}
            <img alt="logo" src={dlzLogo} style={{height: 50, width: 50}}/>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            </Typography>
            {/* <Button sx={{color:"#dddddd"}}>Login</Button> */}
                <Button color="inherit" component={NavLink} to="/" style={linkStyle}>Home</Button>
                <Button color="inherit" component={NavLink} to="/about" style={linkStyle}>About</Button>
                <Button color="inherit" component={NavLink} to="/contact" style={linkStyle}>Contact</Button>
            </Toolbar>
        </AppBar>
        </Box>
  );
}
